export type DeviceAuthStatus = 'idle' | 'required' | 'prompting' | 'verifying' | 'verified' | 'failed' | 'signedOut'

export type PromptKind = 'setup' | 'auth'

export type DeviceAuthState = {
    status: DeviceAuthStatus
    promptKind: PromptKind | null
    error: string | null
}

export type DeviceAuthEvent =
    | { type: 'appAuthenticated' }
    | { type: 'inactivityExpired' }
    | { type: 'promptSetup'; error?: string | null }
    | { type: 'promptAuth'; error?: string | null }
    | { type: 'userChosePasskey' }
    | { type: 'passkeySuccess' }
    | { type: 'passkeyFailure'; error?: string | null }
    | { type: 'userLogout' }
    | { type: 'reset' }

export const initialDeviceAuthState: DeviceAuthState = {
    status: 'idle',
    promptKind: null,
    error: null,
}

export function reduceDeviceAuthState(state: DeviceAuthState, event: DeviceAuthEvent): DeviceAuthState {
    switch (event.type) {
        case 'reset':
            return initialDeviceAuthState
        case 'userLogout':
            return { status: 'signedOut', promptKind: null, error: null }
        case 'appAuthenticated':
            if (state.status === 'verified') return state
            return { status: 'required', promptKind: null, error: null }
        case 'inactivityExpired':
            return { status: 'required', promptKind: null, error: null }
        case 'promptSetup':
            return { status: 'prompting', promptKind: 'setup', error: event.error ?? null }
        case 'promptAuth':
            return { status: 'prompting', promptKind: 'auth', error: event.error ?? null }
        case 'userChosePasskey':
            return { ...state, status: 'verifying', error: null }
        case 'passkeySuccess':
            return { status: 'verified', promptKind: null, error: null }
        case 'passkeyFailure':
            return {
                status: 'failed',
                promptKind: state.promptKind,
                error: event.error ?? state.error ?? null,
            }
        default:
            return state
    }
}
